import { Component } from 'react'
import { $ } from 'utils'

import isFunction from 'lodash/isFunction'
import styled from 'glamorous'

const Root = styled.div({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  // overflowX: 'hidden',
  '&::-webkit-scrollbar': { width: 0, height: 0 },
  msOverflowStyle: 'none',
  overflowY: 'auto',
  padding: 'inherit',
  height: '100%',
  WebkitOverflowScrolling: 'touch',
})

class InertialScrolling extends Component {
  
  // Entry point
  startX = 0
  // Current speed
  speed = 0
  // Need for correct updating speed
  offsetX = 0

  componentDidMount() {
    this.scrollingInterval = setInterval(this.scrolling, 1)
    this.decreaseSpeedInterval = setInterval(this.decreaseSpeed, 100)
  }

  componentWillUnmount() {
    clearInterval(this.scrollingInterval)
    clearInterval(this.decreaseSpeedInterval)
  }

  render() {
    return (
      $(Root, {innerRef: ref => {this.root = ref},
          onMouseMove: this.onMouseMove, onMouseLeave: this.onMouseLeave,
          onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp,
          onScroll: this.onScroll,
        },
        this.props.children)
    )
  }

  onMouseUp = (e) => {
    e.preventDefault()

    this.startX = 0
  }

  onMouseDown = (e) => {
    this.startX = e.clientX
    this.speed = this.speed / 100
  }

  onMouseLeave = () => {
    this.startX = 0
  }

  onMouseMove = (e) => {
    e.preventDefault()

    if (!!this.startX) {
      const offsetX = this.startX - e.clientX
      if (this.props.onMove) this.props.onMove()

      if (Math.abs(offsetX) < Math.abs(this.offsetX)) {
        this.startX = e.clientX
      }

      this.offsetX = this.startX - e.clientX

      this.speed = Math.abs(this.offsetX) < 10 ? this.offsetX : this.offsetX * 0.1
    }
  }

  onScroll = () => {
    const {loadMore} = this.props
    const currentScrollPosition = this.root.scrollLeft + this.root.offsetWidth
    const scrollWidth = this.root.scrollWidth

    if (scrollWidth - this.root.offsetWidth < currentScrollPosition && isFunction(loadMore)) {
       loadMore()
    }
  }

  scrolling = () => {
    if (!!this.speed) {
      const speed = Math.ceil(Math.abs(this.speed) * 0.3) * (this.speed > 0 ? 1 : -1)
      this.root.scrollLeft = this.root.scrollLeft + speed
    }
  }

  decreaseSpeed = () => {
    if ((this.speed < 1 && this.speed > 0) || (this.speed > -1 && this.speed < 0)) {
      this.speed = 0
    } else if (this.speed > 0) {
      this.speed = this.speed - 1
    } else if (this.speed < 0) {
      this.speed = this.speed + 1
    }
  }
}

export default InertialScrolling



// WEBPACK FOOTER //
// ./src/components/InertialScrolling.js